import styled from "@emotion/styled";
import { Styles } from "@tpd-web-common-libs/nodejs-library";

const Icons = `
  .tpd-icon {
    color: #fff;
    display: inline;
    font-size: 40px;
    padding: 3px;
  }

  .tpd-expand {
    font-size: 26px;
    background: none;
    border: none;
    cursor: pointer;
  }

  a {
    text-decoration: none;
  }
`;

export const ContainerDiv = styled.div`
  &.hidden {
    display: none;
  }

  &.footer-with-sticky-space {
    ${Styles.BreakpointsUtils.desktopOnly(`
        margin-bottom: 125px;
    `)}

    ${Styles.BreakpointsUtils.tabletOnly(`
        margin-bottom: 56px;
    `)}

    ${Styles.BreakpointsUtils.mobileOnly(`
        margin-bottom: 108px;
    `)}
  }

  line-height: 1.42857143;
  width: 100%;
  height: 100%;
  ${Icons}

  .tpd-image {
    margin-top: 10px;
    width: 50%;
  }

  .phone-cont {
    width: -webkit-fill-available;
    aspect-ratio: 211 / 392;
  }

  .tpd-image-container {
    width: 40px;
    height: 40px;
    padding: 4px;

    .tpd-image-preview-mode-container {
      height: 100%;
      img {
        height: 100%;
      }
    }
  }

  .style-CTA-ios {
    aspect-ratio: 77 / 27;
    width: 154px;
  }

  .style-CTA-Android {
    aspect-ratio: 157 / 54;
    width: 154px;
  }
`;

export const SocialBanner = styled.div`
  background: ${Styles.Themes.UnipolColors.blueOne};
  ${Styles.TouchpointUtils.touchpointThemeOnly(
    (touchpoint: any) => `
      background: ${touchpoint.mainColor};
    `
  )}

  display: flex;
  align-items: center;
  justify-content: center;
  height: 105px;
  font-family: Unipol;
  font-size: 16px;

  ${Styles.BreakpointsUtils.mobileOnly(`
    flex-direction: column;
    height: 145px;
  `)}

  span {
    color: white;
    font-family: Unipol Medium;
    font-size: 24px;
    margin-right: 10px;

    ${Styles.BreakpointsUtils.mobileOnly(`
      font-family: Unipol;
      padding-bottom: 20px;
      margin-right:0px;
    `)}
  }
`;

export const TpdMainList = styled.div`
  background: ${Styles.Themes.UnipolColors.blueOne};
  ${Styles.TouchpointUtils.touchpointThemeOnly(
    (touchpoint: any) => `
      background: ${touchpoint.mainColor};
    `
  )}

  display: flex;
  align-items: center;
  justify-content: space-evenly;
  height: 75px;
  border-top: 2px solid #fff;
  font-family: Unipol Medium;
  padding: 0 2.5%;
  span {
    color: white;
    font-size: 16px;
  }

  .list-item {
    min-width: 100px;
    text-align: center;
  }

  ${Styles.BreakpointsUtils.mobileOnly(`
    flex-direction: column;
    height: auto;

    .list-item {
      width: auto;
      min-width: none;
      padding: 10px;
    }
  `)}

  .privacy-link-img-accessiway {
    background: #004fce;
    border-radius: 50%;
    height: 35px;
    padding: 5px;
    width: 35px;
  }
`;

export const TpdListImage = styled.div`
  display: flex;
  max-width: 1045px;
  padding-top: 40px;
  margin: auto;

  ${Styles.BreakpointsUtils.tabletOnly(`
      height: 100%;
      padding: 3% 5% 0 5%;  
    `)}
  ${Styles.BreakpointsUtils.mobileOnly(`
      flex-direction: column-reverse;
      padding: 3% 7% 0 7%;
    `)}

  }
`;

export const TpdTitleImage = styled.div`
  width: 50%;
  max-width: 500px;
  padding: 60px 20px;
  border-left: 1px ridge;
  margin-bottom: 10px;
  overflow-x: hidden;

  ${Styles.BreakpointsUtils.mobileAndTabletOnly(`
    border-left: none;
  `)}

  ${Styles.BreakpointsUtils.mobileOnly(`
    width: 100%;
    padding: 40px 0px 0px 0px;
  `)}

  span {
    color: ${Styles.Themes.UnipolColors.blueSix};
    ${Styles.TouchpointUtils.touchpointThemeOnly(
      (touchpoint: any) => `
        color: ${touchpoint.secondaryColor};
      `
    )}

    font-family: Unipol Medium;
    &:hover {
      color: ${Styles.Themes.UnipolColors.blueThree};
    }

    ${Styles.BreakpointsUtils.desktopOnly(`
        font-size: 40px;
    `)}

    ${Styles.BreakpointsUtils.tabletOnly(`
        font-size: 33px;
    `)}

    ${Styles.BreakpointsUtils.mobileOnly(`
      font-size: 24px;
    `)}
  }

  .tpd-apps-image {
    width: 100%;
    display: flex;

    ${Styles.BreakpointsUtils.mobileOnly(`
        padding: 0;
    `)}

    .tpd-apps {
      display: flex;
      flex-direction: column;
      gap: 20px;
      width: 50% ${Styles.BreakpointsUtils.mobileAndTabletOnly(`
        gap: 10px;
        a {
          img {
            width: 100%;
            object-fit: contain;
            max-width: 154px;
            height: 54px;
            }
          }
        }
      `)} .tpd-title {
        width: 100%;

        ${Styles.BreakpointsUtils.desktopOnly(`
            line-height: 40px;
            margin: 10px 0px 5px 0px;
        `)}
        ${Styles.BreakpointsUtils.tabletOnly(`
            margin-top: 10px;
            margin-bottom: 0;
        `)}
        ${Styles.BreakpointsUtils.mobileOnly(`
            width: calc(100% * 21/24);
        `)}
      }

      .tpd-title:hover span {
        color: ${Styles.Themes.UnipolColors.blueSeven};

        ${Styles.TouchpointUtils.touchpointThemeOnly(
          (touchpoint: any) => `
            color: ${touchpoint.darkQuaternaryColor};
          `
        )}
      }
    }

    .tpd-qrcode-image {
      width: 155px;
      aspect-ratio: 155 / 155;
    }
  }
`;

export const TpdCompany = styled.div`
  width: 100%;
  max-width: 1280px;
  line-height: 1.42857;
  height: auto;

  b {
    font-family: "Unipol Medium";
  }

  .tpd-contacts-title {
    color: #9b9b9b;
    font-family: Unipol Medium;
    font-size: 16px;
  }

  .tpd-contacts {
    width: 100%;
    padding-top: 30px;
    padding-bottom: 40px;
    padding-left: 4px;

    ${Styles.BreakpointsUtils.tabletOnly(`
      border-right: 0;
    `)}
    ${Styles.BreakpointsUtils.mobileOnly(`
      width: 100%;
    `)}
    
    .tpd-contacts-content {
      ${Styles.BreakpointsUtils.desktopOnly(`
        width: 522px;
      `)}
      ${Styles.BreakpointsUtils.tabletOnly(`
        width:622px;
    `)}
    }

    p {
      color: #9b9b9b;
      font-family: Unipol;
      font-size: 16px;
      margin: 0;
      line-height: 20px;

      a{
        color: #9b9b9b;
        text-decoration:underline;
      }
    }
    .small {
      margin-top: 10px;
      font-size: 14px;
      line-height: 1.3;
    }
  }
`;

export const TpdList = styled.div`
  max-width: 530px;
  ${Styles.BreakpointsUtils.tabletOnly(`
      width: 50%;
  `)}

  ${Styles.BreakpointsUtils.mobileOnly(`
      width: 100%;
  `)}

  span {
    color: ${Styles.Themes.UnipolColors.blueOne};
    ${Styles.TouchpointUtils.touchpointThemeOnly(
      (touchpoint: any) => `
        color: ${touchpoint.mainColor};
      `
    )}

    font-family: Unipol Medium;
    font-size: 16px;
    cursor: pointer;
    line-height: 10px;
  }

  .tpd-list-items {
    max-width: 500px;
    border-right: 0px;

    ${Styles.BreakpointsUtils.desktopOnly(`
        column-count: 2;
      `)}

    ${Styles.BreakpointsUtils.tabletOnly(`
        border-right: 1px ridge;
      `)}
  }

  .list-item {
    margin-top: 10px;

    .collapsible {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      span:hover {
        color: ${Styles.Themes.UnipolColors.blueThree};
        ${Styles.TouchpointUtils.touchpointThemeOnly(
          (touchpoint: any) => `
            color: ${touchpoint.darkSecondaryColor};
          `
        )}
      }
      .tpd-expand {
        color: ${Styles.Themes.UnipolColors.blueOne};
        ${Styles.BreakpointsUtils.desktopOnly(`
            display: none;
        `)}
      }
    }

    .content {
      ${Styles.BreakpointsUtils.desktopOnly(`
          display: block;
      `)}

      ${Styles.BreakpointsUtils.mobileAndTabletOnly(`
          display: none;
          overflow: hidden;
      `)}

      span {
        color: ${Styles.Themes.UnipolColors.blueSeven};
        ${Styles.TouchpointUtils.touchpointThemeOnly(
          (touchpoint: any) => `
            color: ${touchpoint.darkQuaternaryColor};
          `
        )}
        cursor: pointer;
      }
    }

    .content span:hover {
      color: ${Styles.Themes.UnipolColors.blueSeven};
      ${Styles.TouchpointUtils.touchpointThemeOnly(
        (touchpoint: any) => `
          color: ${touchpoint.darkQuaternaryColor};
        `
      )}
    }

    .visible {
      display: block;
    }

    .hidden {
      ${Styles.BreakpointsUtils.desktopOnly(`
        display: block;
      `)}

      ${Styles.BreakpointsUtils.mobileAndTabletOnly(`
        display: none;
      `)}
    }
  }
`;

export const TpdInfo = styled.div`
  background: ${Styles.Themes.UnipolColors.blueOne};
  ${Styles.TouchpointUtils.touchpointThemeOnly(
    (touchpoint: any) => `
      background: ${touchpoint.mainColor};
    `
  )}

  color: #fff;
  font-family: Unipol;
  font-size: 14px;
  min-height: 195px;
  padding-bottom: 20px;

  ${Styles.BreakpointsUtils.mobileOnly(`
    min-height: 0;
    padding-bottom: 0;
  `)}

  .tpd-red-row {
    width: 100%;
    height: 5px;
    display: flex;

    .tpd-blue {
      width: 33%;
    }

    .tpd-red {
      width: 33%;
      background-color: #c4151c;
    }
  }

  .info {
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 20px;
    margin: auto;
    width: calc(100% * 22 / 24);
    line-height: 20px;
    p {
      margin-bottom: 0;
    }

    ${Styles.BreakpointsUtils.desktopOnly(`
      max-width: 1167px;
    `)}

    ${Styles.BreakpointsUtils.tabletOnly(`
      max-width: 685px;
    `)}

    ${Styles.BreakpointsUtils.mobileOnly(`
      padding-top:10px;
      padding-bottom: 16px;
    `)}
  }

  .visibility {
    ${Styles.BreakpointsUtils.mobileOnly(`
      display:none;
    `)}
  }

  .visibility-data {
    color: white;
    text-align: center;
    text-decoration: underline;
    font-size: 14px;
    font-family: Unipol Medium;
    cursor: pointer;
    padding: 10px;
    ${Styles.BreakpointsUtils.tabletAndDesktopOnly(`
        display:none;
    `)}
    ${Styles.BreakpointsUtils.mobileOnly(`
        display:block;
        margin-bottom: 0;
    `)}
  }
`;
